// Components==============
import { motion } from 'framer-motion';
import { useScrollFreeze } from 'hooks/useScrollFreeze';
import React from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import './Shade.module.scss';
// =========================

export default function Shade({ onClick }: { onClick?: () => void }) {
  useScrollFreeze();

  return <motion.div styleName="shade" onClick={onClick} {...framerFade} />;
}
